import React from 'react';
import PropTypes from 'prop-types';
import {DrawerHandle} from '../DrawerHandle';
import {ReactDrawer} from '../ReactDrawer';

export function NotebookDrawer(props) {
  const renderDrawerHandle = () =>
    !props.visible && (
      <DrawerHandle collapsed={true} toggleCollapse={props.toggleCollapse} />
    );

  return (
    <>
      {renderDrawerHandle()}
      <ReactDrawer visible={props.visible} showOverlay={props.showOverlay}>
        {props.children}
      </ReactDrawer>
    </>
  );
}

NotebookDrawer.propTypes = {
  /**
   * Boolean value to specify if overlay should be displayed
   */
  showOverlay: PropTypes.bool.isRequired,
  /**
   * Function to invoke when clicked on DrawerHanlder in
   * collapsed mode
   */
  toggleCollapse: PropTypes.func.isRequired,
  /**
   * Boolean specifying if the drawer is visible
   */
  visible: PropTypes.bool,
  /**
   * Child component to be displayed inside the drawer
   */
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.element])
    .isRequired,
};

NotebookDrawer.defaultProps = {
  visible: false,
  showOverlay: true,
};
